<template>
  <apexcharts type="rangeBar" height="350" :options="timelineChartOptions" :series="chartReleases"></apexcharts>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {apexcharts: VueApexCharts,},
  name: 'ReleasesChart',
  props: {
    releases: {
      type: Object,
      required: true
    },
    tab: {
      type: Number,
      required: true
    }
  },
  methods: {},
  computed: {
    chartReleases() {
      const data = [];

      function getColor(env) {
        if (env == 'UAT') {
          return '#76b0e3'
        } else if (env == 'INT') {
          return '#ccddf6'
        } else if (env == 'QAT') {
          return '#ecd4d9'
        } else if (env == 'DEV') {
          return '#b58a80'
        } else if (env == 'OAT') {
          return '#4f75ca'
        } else if (env == 'PRD') {
          return '#000000'
        }
        return '#FFFFFF'
      }

      if (this.tab != null) {
        for (let env of Object.keys(this.releases)) {
          const deploymentData = {data: [], name: env, color: getColor(env)}

          for (let deployment of this.releases[env].current) {
            deploymentData.data.push({
              x: deployment.artifact,
              y: [
                new Date(deployment.completedOn.timestamp * 1000).getTime(), // startedOn
                new Date(deployment.completedOn.timestamp * 1000 + 10e6).getTime() // put real end time?
              ],
              ver: deployment.sources[0].buildno
            })
          }
          data.push(deploymentData);
        }
      }
      return data
    }
  },
  data() {
    return {
      timelineChartOptions: {
        chart: {
          height: 350,
          type: 'rangeBar',
          toolbar: {
            show: true
          },
          legendClicked: false,
          events: {
            legendClick: function legendClick(chartContext, seriesIndex, config) {
              const {series} = config.config;
              const selectedSeriesItemName = series[seriesIndex].name;
              chartContext.resetSeries()
              if (chartContext.showSoloLegend) {
                chartContext.showSoloLegend = !chartContext.showSoloLegend
              } else {
                chartContext.showSoloLegend = true
              }
              if (chartContext.showSoloLegend) {
                series.forEach((seriesItem) => {
                  if (seriesItem.name !== selectedSeriesItemName) {
                    chartContext.hideSeries(seriesItem.name);
                  }
                });
              }
            },
          },
        },
        legend: {
          show: true,
          onItemClick: {
            toggleDataSeries: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          custom: function (opts) {
            let datapoint = opts.ctx.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]
            return "<b>" + opts.ctx.w.config.series[opts.seriesIndex].name + "</b>" + datapoint.ver
          }
        }
      },
    }
  }
}
</script>
<style scoped>
</style>